export default __webpack_public_path__ + "static/media/tuft-and-needle.452b2546.svg";